var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',_vm._g(_vm._b({staticClass:"button-bubble",class:{
    'button-bubble--primary': _vm.primary,
    'button-bubble--is-disabled': !_vm.isActive,
  }},'BaseButton',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"button-bubble__inner"},[_c(_vm.iconComponent,{tag:"component",staticClass:"button-bubble__icon"}),_c('span',{staticClass:"button-bubble__label"},[_vm._v(_vm._s(_vm.label))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }